import { allRollbackStackingConfigOptions, RollbackStackingConfig } from './types';

export const isRollbackStackingConfigValid = (
  rollbackStackingConfig: string,
): rollbackStackingConfig is RollbackStackingConfig =>
  allRollbackStackingConfigOptions.includes(rollbackStackingConfig as RollbackStackingConfig);
